import {
  BookOpen,
  Brain,
  Calendar,
  Camera,
  Clock,
  Cloud,
  Grid3x3,
  Heart,
  Home,
  Laugh,
  TrendingUp,
  Utensils,
  Wheat,
  Zap,
} from 'lucide-react';

/**
 * Render a Lucide icon by name string. Used by Layout to render
 * vertical-specific icons from config without dynamic component creation.
 */
export function IconByName({ name, className }: { name: string; className?: string }) {
  switch (name) {
    case 'BookOpen':
      return <BookOpen className={className} />;
    case 'Brain':
      return <Brain className={className} />;
    case 'Calendar':
      return <Calendar className={className} />;
    case 'Camera':
      return <Camera className={className} />;
    case 'Clock':
      return <Clock className={className} />;
    case 'Cloud':
      return <Cloud className={className} />;
    case 'Grid':
      return <Grid3x3 className={className} />;
    case 'Heart':
      return <Heart className={className} />;
    case 'Home':
      return <Home className={className} />;
    case 'Laugh':
      return <Laugh className={className} />;
    case 'TrendingUp':
      return <TrendingUp className={className} />;
    case 'Utensils':
      return <Utensils className={className} />;
    case 'Wheat':
      return <Wheat className={className} />;
    case 'Zap':
      return <Zap className={className} />;
    default:
      return <Cloud className={className} />;
  }
}
